import * as R from 'ramda'

export const mergeRefs = refs => value => {
  refs.forEach(ref => {
    const isRefTypeOfFunction = R.equals(typeof ref, 'function')
    const isRefAvailable = R.not(R.isNil(ref))

    if (isRefTypeOfFunction) {
      ref(value)
    } else if (isRefAvailable) {
      ref.current = value
    }
  })
}
